import React, { useEffect, useState } from "react";
import BurgerMenuTitle from "../../../Component/BurgerMenuTitle/BurgerMenuTitle";
import { getFactorListApi, getFactureByIdAPI } from "../../../Api/BarestServices";
import { Skeleton } from "antd";
import FactureItem from "./FactureItem/FactureItem";
import SearchFactur from "./SearchFactur/SearchFactur";
import { errorToast } from "../../../Toast/Toast";

const FactureList = () => {
  const [factorListState, setFactorListState] = useState();
  const [loadingState, setLoadingState] = useState(false);
  useEffect(() => {
    getFactorListHandler();
  }, []);
 const getFactorListHandler = () => {
    getFactorListApi((succ, res) => {
      if (succ) {
        if (res.status === 1) {
          const sortedFactures = res.facture?.sort((a, b) => {
            if (a.status === "0" && b.status !== "0") return -1; 
            if (b.status === "0" && a.status !== "0") return 1; 
            return Number(b.id) - Number(a.id);
          });
          
          setFactorListState(sortedFactures);
        }
      } else {
        console.error(res);
      }
    });
  };
  const onSearchFacture = (id) => {
    setLoadingState(true);
    getFactureByIdAPI(id, (succ, res) => {
      if (succ) {
        if (res.status === 1) {
          setFactorListState([res.facture]);
          setLoadingState(false);
        } else {
          errorToast(res.message);
          setLoadingState(false);
        }
      } else {
        setLoadingState(false);
        console.error(res);
      }
    });
  };
  return (
    <div style={{ width: "100%" }}>
      <BurgerMenuTitle title="فاکتور های اصلاحی" />
      <div style={{ maxWidth: "450px", margin: "3rem auto", width: "100%" }}>
        <SearchFactur onSearchFacture={onSearchFacture} loadingState={loadingState}/>
        {!factorListState && (
          <Skeleton
            active
            style={{ maxWidth: "450px", margin: "3rem auto", width: "100%" }}
          />
        )}
        {factorListState?.length === 0 ? (
          <p>در حال حاضر فاکتوری وجود ندارد!</p>
        ) : (
          factorListState?.map((item) => {
            return <FactureItem key={item.id} data={item} />;
          })
        )}
      </div>
    </div>
  );
};

export default FactureList;
